let sha1 = require("crypto-js/sha1");
let wordArray = require("crypto-js/lib-typedarrays");

/**
 * Read File for FileSystem
 *
 * @param file {File}
 * @returns {Promise}
 */
function readFile(file) {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.readAsArrayBuffer(file)
  })
}

/**
 * Get File Proof Data for Blockchain Network
 *
 * @param file {File}
 * @param host {string}
 * @returns {string}
 */
export default async function (file, host) {
  let fileContent = await readFile(file);
  let fileHash = sha1(wordArray.create(fileContent)).toString();

  return await fetch(`${host}/${fileHash}`)
    .then((r) => {
      if (r.ok) {
        return r.json();
      }

      return {};
    })
    .then((data) => {
      return data
    })
}
